import React from 'react';
import brandSymbolAvif from '../assets/brand/wafaa-symbol.avif';
import brandSymbolWebp from '../assets/brand/wafaa-symbol.webp';
import brandSymbolPng from '../assets/brand/wafaa-symbol.png';

export default function BrandMark({ alt = 'Wafaa Loyalty', className = '', style }) {
  return (
    <picture>
      <source srcSet={brandSymbolAvif} type="image/avif" />
      <source srcSet={brandSymbolWebp} type="image/webp" />
      <img src={brandSymbolPng} alt={alt} className={className} style={style} width="1024" height="1024" decoding="async" />
    </picture>
  );
}
